<template>
  <div :key="currentStep + '_progressbar'">
    <p>
      You are at
      {{
        currentStep > 0
          ? ` week ${currentStep} out of ${runToEndFinishesAt}`
          : ` the start of ${runToEndFinishesAt} weeks`
      }}
    </p>
    <div class="progress run-progress">
      <div
        class="progress-bar progress-bar-warning"
        role="progressbar"
        aria-valuenow="currentStep / runToEndFinishesAt * 100"
        aria-valuemin="0"
        aria-valuemax="100"
        :style="'width:' + (currentStep / runToEndFinishesAt) * 100 + '%'"
      >
        <span class="sr-only">60% Complete</span>
      </div>
    </div>
  </div>
</template>

<script>
import data from "../services/data";

export default {
  data() {
    return {
      currentRun: this.$root.$data.sharedStorage.getCurrentRun(),
      currentStep: 0,
      runToEndFinishesAt: data.runToEndFinishesAt
    };
  },
  created() {
    this.currentStep = this.currentRun.getCurrentStep();
  },
  updated() {
    this.currentStep = this.currentRun.getCurrentStep();
  }
};
</script>

<style lang="scss">
.run-progress {
  width: 100%;
}
</style>
